var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-badge",
    {
      attrs: { avatar: "", bordered: "", overlap: "", color: "red" },
      scopedSlots: _vm._u([
        {
          key: "badge",
          fn: function () {
            return [
              _c("div", { staticStyle: { "line-height": "20px" } }, [
                _vm._v("T"),
              ]),
            ]
          },
          proxy: true,
        },
      ]),
      model: {
        value: _vm.temp,
        callback: function ($$v) {
          _vm.temp = $$v
        },
        expression: "temp",
      },
    },
    [
      _c(
        "v-avatar",
        {
          class: _vm.contentClass,
          style: {
            border: _vm.border ? "1px solid rgba(0, 0, 0, 0.1)" : "none",
            cursor: "pointer",
          },
          attrs: {
            size: _vm.small ? 24 : _vm.size,
            left: _vm.left,
            tile: _vm.tile,
            "max-width": _vm.small ? 24 : _vm.size,
            "max-height": _vm.small ? 24 : _vm.size,
            right: _vm.right,
            rounded: _vm.rounded,
            color: _vm.color
              ? _vm.color
              : _vm.src && !_vm.isError
              ? "transparent"
              : _vm.avatarColor,
          },
          on: { click: _vm.triger },
        },
        [
          _vm.src && !_vm.isError
            ? _c("v-img", {
                staticClass: "teansparent",
                attrs: {
                  src: _vm.src,
                  width: "100%",
                  height: "100%",
                  alt: _vm.$getCommonLangValue(_vm.staff_name),
                  "aspect-ratio": "1",
                },
                on: {
                  load: function ($event) {
                    _vm.isError = false
                  },
                  error: function ($event) {
                    _vm.isError = true
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "placeholder",
                      fn: function () {
                        return [
                          _c(
                            "v-sheet",
                            {
                              staticClass:
                                "\n            transparent\n            max-width\n            fill-height\n            d-flex\n            align-center\n            justify-center\n          ",
                            },
                            [
                              _c("v-progress-circular", {
                                attrs: {
                                  width: 2,
                                  size: _vm.small ? 12 : _vm.size / 2,
                                  color: "primary",
                                  indeterminate: "",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  2313890406
                ),
              })
            : _c(
                "span",
                {
                  staticClass: "white--text",
                  style: {
                    fontSize: _vm.getFontSize(_vm.small ? 24 : _vm.size),
                    lineHeight: (_vm.small ? 24 : _vm.size) + "px",
                  },
                },
                [
                  _vm._v(
                    _vm._s(_vm.getName(_vm.$getCommonLangValue(_vm.staff_name)))
                  ),
                ]
              ),
          _vm._t("default"),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }